import React from 'react';
import { FaRocket, FaUsers, FaLightbulb, FaHandshake } from 'react-icons/fa';
import TeamSection from '../components/TeamSection';

const values = [
  {
    icon: <FaRocket />,
    title: 'Innovation',
    description: 'Pushing the boundaries of AI technology to deliver cutting-edge solutions.'
  },
  {
    icon: <FaUsers />,
    title: 'Collaboration',
    description: 'Working closely with clients to understand and meet their unique needs.'
  },
  {
    icon: <FaLightbulb />,
    title: 'Excellence',
    description: 'Committed to delivering the highest quality solutions and service.'
  },
  {
    icon: <FaHandshake />,
    title: 'Trust',
    description: 'Building long-lasting relationships based on transparency and reliability.'
  }
];

const About = () => {
  return (
    <div className="min-h-screen bg-nvidia-dark py-20">
      <div className="container mx-auto px-6">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            About <span className="text-nvidia-green">Us</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            At Botrex AI, we're a collective of forward-thinkers, innovators, and problem solvers united by a singular vision: unlocking the true potential of AI for businesses worldwide. Our team brings together elite AI researchers, seasoned developers, and strategic consultants who thrive on turning complex challenges into elegant solutions.
          </p>
        </div>

        {/* Mission Section */}
        <div className="bg-nvidia-dark-800 rounded-lg p-8 md:p-12 mb-16 border border-nvidia-green/20">
          <h2 className="text-3xl font-bold mb-6">Our Mission</h2>
          <p className="text-gray-400 text-lg leading-relaxed">
            To empower businesses with cutting-edge AI solutions that drive growth, innovation, and success. We believe in making artificial intelligence accessible and practical for organizations of all sizes.
          </p>
        </div>

        {/* Team Section */}
        <TeamSection />

        {/* Values Section */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold mb-12 text-center">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="text-center p-6 bg-nvidia-dark-800 rounded-lg border border-nvidia-green/20 hover:border-nvidia-green/40 transition-colors"
              >
                <div className="text-nvidia-green text-4xl mb-4">
                  {value.icon}
                </div>
                <h3 className="text-xl font-bold mb-3">{value.title}</h3>
                <p className="text-gray-400">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Team Section */}
        <div className="text-center">
          <h2 className="text-3xl font-bold mb-6">Our Team</h2>
          <p className="text-gray-400 text-lg mb-8">
            We're a diverse team of AI experts, developers, and business consultants working together to deliver exceptional results.
          </p>
          <button className="bg-nvidia-green text-black px-8 py-3 rounded-lg font-semibold hover:bg-opacity-90 transition-colors">
            Join Our Team
          </button>
        </div>
      </div>
    </div>
  );
};

export default About;
